/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.DocumentSetsClarificationRequests = {

  _priorityClasses: {
    '-1': 'low',
    '0': 'normal',
    '1': 'high'
  },

  _priorityLabels: {
    '-1': 'Low',
    '0': 'Normal',
    '1': 'High'
  },


  _renderStatus(params) {
    return `<div class='status-label rfc-status ${params.data.state}'>${params.data.state}</div>`;
  },

  _renderPriority(params) {
    const priority_string = String(params.data.priority);
    const priority = this._priorityClasses[priority_string];
    const label = this._priorityLabels[priority_string];
    return `<span><span class='data-value rfc-priority ${priority}'></span>${label}</span>`;
  },

  _renderName(params) {
    return `<a href='${params.data.source_path}'>${params.data.title}</a>`;
  },

  _renderVisibility(params, bidder) {
    let text, title;
    const visibility = params.data.visibility;

    if (visibility === 'public') {
      text = I18n.t('v4.clarification_requests.visibility.public.text');
      title = 'Title';
    } else if (visibility === 'private') {
      text = I18n.t('v4.clarification_requests.visibility.private.text');
      if (bidder) {
        title = I18n.t('v4.clarification_requests.visibility.private.title.bidder');
      } else {
        title = I18n.t('v4.clarification_requests.visibility.private.title.issuer');
      }
    } else if (visibility === 'restricted') {
      text = I18n.t('v4.clarification_requests.visibility.restricted.text');
      if (bidder) {
        title = I18n.t('v4.clarification_requests.visibility.restricted.title.bidder');
      } else {
        title = I18n.t('v4.clarification_requests.visibility.restricted.title.issuer');
      }
    } else if (visibility === 'exclusive') {
      text = I18n.t('v4.clarification_requests.visibility.exclusive.text');
      if (bidder) {
        title = I18n.t('v4.clarification_requests.visibility.exclusive.title.bidder');
      } else {
        title = I18n.t('v4.clarification_requests.visibility.exclusive.title.issuer');
      }
    }

    return `<span data-tooltip="" aria-haspopup='true' class='data-value has-tip tip-top visibility-${visibility}' title='${title}'>${text}</span>`;
  },

  initializeTable(tableSelector, params, bidder) {

    const data = _.map(params, doc => JSON.parse(doc));

    const columnDefs =
      [
        { headerName: 'Name', field: 'name', cellRenderer: issue => this._renderName(issue) },
        { headerName: I18n.t('v4.clarification_requests.issued_by'), field: 'issued_by' },
        { headerName: I18n.t('v4.clarification_requests.replies'), field: 'replies' },
        { headerName: 'Update', field: 'last_updated' },
        { headerName: I18n.t('v4.clarification_requests.priority'), field: 'priority', width: 100, cellRenderer: priority => this._renderPriority(priority) },
        { headerName: 'Status', field: 'status', width: 120, cellRenderer: issue => this._renderStatus(issue) },
        { headerName: 'Title', field: 'visibility', width: 120, cellRenderer: issue => this._renderVisibility(issue, bidder) }
      ];

    const gridOptions = {
      paginationPageSize: 10,
      headerHeight: 44,
      rowHeight: 44,
      columnDefs,
      rowData: data,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      onGridSizeChanged(event) {
        event.api.sizeColumnsToFit();
        // Reinitialize tooltips when grid size changes (e.g., sidebar expand/collapse)
        setTimeout(() => $('[data-tooltip]').foundation('tooltip'), 100);
      },
      onGridReady(event) {
        event.api.sizeColumnsToFit();
        setTimeout(() => $('[data-tooltip]').foundation('tooltip'), 100);
      },
      onFilterChanged(event) {
        setTimeout(() => $('[data-tooltip]').foundation('tooltip'), 100);
      },
      onSortChanged(event) {
        setTimeout(() => $('[data-tooltip]').foundation('tooltip'), 100);
      },
      onPaginationChanged(event) {
        setTimeout(() => $('[data-tooltip]').foundation('tooltip'), 100);
      }
    };

    const gridDiv = document.getElementById(tableSelector);
    const gridApi = agGrid.createGrid(gridDiv, gridOptions);
    gridOptions.api = gridApi;

    // Reinitialize tooltips when grid content changes with debouncing
    const gridContainer = document.querySelector(`#${tableSelector} .ag-center-cols-container`);
    if (gridContainer) {
      let tooltipTimeout;
      const observer = new MutationObserver(() => {
        clearTimeout(tooltipTimeout);
        tooltipTimeout = setTimeout(() => {
          $('[data-tooltip]').foundation('tooltip');
        }, 50);
      });
      observer.observe(gridContainer, { childList: true, subtree: true });
    }

    return resizeAgGridTable(`#${tableSelector}`, gridOptions, 0, false, false);
  },

  initilizeShowDropdown() {
    return $('.visibility-choice').on('click', function () {
      $('#visibility-content').html($(this).html());
      Foundation.libs.dropdown.close($('#visibility-drop'));
      $('#visibility-value').val($(this).data('visibility'));
      return $('.edit_clarification_request').submit();
    });
  }
};
